import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { ActionTypes as Type } from '../../actions/favorite';
import btnClose from '../../images/common/close.svg';
import Checkbox from '../Parts/Checkbox';
import SortMark from '../Parts/SortMark';
import UserIcon from '../Parts/UserIcon';
import AppButton from '../../styles/common/AppButton';
import {
  deleteFavorite,
  updateFavorite,
  createFavorite,
} from '../../actions/api/apis';
import {
  MAX_REMOTE_OPPOSITE_NUM,
  REMOTE_SUPPORT_STATUS,
} from '../../lib/constants';
import ColorSF2 from '../../styles/common/ColorSF2';
import SearchBox from '../Parts/SearchBox';
import {
  MainBlock,
  DialogBox,
  HeaderBlock,
  CloseButton,
  CloseButtonImage,
  BodyBlock,
  ContentWrapper,
  InputWrapper,
  InputTitle,
  Input,
  SubTitle,
  RemoteActionWrapper,
  RemoteMembersWrapper,
  RemoteMember,
  MemberName,
  CancelButton,
  CancelButtonImage,
  AllClearButton,
  Table,
  Thead,
  TheadTr,
  ThCheckbox,
  ThOperatorName,
  ScrolledBody,
  Tbody,
  TbodyTr,
  TdCheckbox,
  TdOperatorName,
  OperatorNameWrapper,
  OperatorName,
  ButtonWrapper,
  SortWrapper,
} from './styles/FavoriteDialogStyles';

const FavoriteDialog = ({
  apiToken,
  dispatch,
  userInfo,
  oppositeOperators,
  favorite,
  groupId,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const operatorsInGroup = useSelector(state => state.operator.operators);

  const close = () => dispatch({ type: 'CLOSE_FAVORITE_DIALOG' });
  const onCreate = params => dispatch(createFavorite(apiToken, params));
  const onUpdate = (id, params) =>
    dispatch(updateFavorite(apiToken, id, params));
  const onDelete = id => {
    const promptMessage = formatMessage({ id: 'userPrompt.message.delete' });
    const buttonOk = formatMessage({ id: 'userPrompt.button.delete' });
    const buttonNo = formatMessage({ id: 'userPrompt.button.noDelete' });
    const buttonArray = [
      { name: buttonOk, type: 0 },
      { name: buttonNo, type: 1 },
    ];
    const onAccept = ret => {
      if (ret === 0) {
        dispatch(deleteFavorite(apiToken, id));
      }
    };
    dispatch({
      type: 'OPEN_USER_PROMPT',
      promptMessage,
      buttonArray,
      onAccept,
    });
  };
  const favoriteOperatorIds = favorite.operatorIds || [];
  const oppositeFavoriteOperatorIds = favoriteOperatorIds.filter(
    operatorId =>
      operatorId !== userInfo.operatorId &&
      operatorsInGroup.some(operator => operator.operatorId === operatorId),
  );
  const disabled = !favorite.name || !oppositeFavoriteOperatorIds.length;
  const noChecked =
    oppositeFavoriteOperatorIds && oppositeFavoriteOperatorIds.length === 0;
  // チェックボックス表示対象
  const [filterOperators, setFilterOperators] = useState(
    oppositeOperators || [],
  );
  const checkAll = checked =>
    dispatch({
      type: Type.CHECK_ALL_OPERATORS,
      checked,
      filterIds: filterOperators.map(({ operatorId }) => operatorId),
    });
  const resetCheckbox = () => dispatch({ type: Type.RESET_CHECK_OPERATORS });
  const toggleCheckbox = id => dispatch({ type: Type.CHECK_OPERATOR, id });
  // チェック可能かどうか
  const enabledCheck =
    MAX_REMOTE_OPPOSITE_NUM > oppositeFavoriteOperatorIds.length;
  // チェック済チェックボックス数
  const checkedTargetCount = filterOperators.filter(operator =>
    oppositeFavoriteOperatorIds.some(
      operatorId => operatorId === operator.operatorId,
    ),
  ).length;
  // 表示されているチェックボックス数が、チェック可能数以内の場合は全チェックボックスを表示する
  const showAllCheckbox =
    filterOperators.length > 0 &&
    oppositeFavoriteOperatorIds.length -
      checkedTargetCount +
      filterOperators.length <=
      MAX_REMOTE_OPPOSITE_NUM;
  // ソート関連
  const [sortOn, setSortOn] = useState(false);
  const [sortDesc, setSortDesc] = useState(false);
  const clickSort = () => {
    if (!sortOn) {
      setSortOn(true);
    }
    setSortDesc(!sortDesc);
  };
  const [namePartial, setNamePartial] = useState('');

  useEffect(() => {
    const work = oppositeOperators.filter(operator => {
      const nameFilter = operator.name
        .toLowerCase()
        .includes(namePartial.toLowerCase());
      const licenseFilter =
        operator.remoteSupportStatus === REMOTE_SUPPORT_STATUS.enable;
      return nameFilter && licenseFilter;
    });
    if (sortOn) {
      const result = (sortDesc && 1) || -1;
      work.sort((a, b) => (a.name < b.name ? -1 * result : result));
    }
    setFilterOperators(work);
  }, [oppositeOperators, namePartial, sortOn, sortDesc]);

  return (
    <MainBlock id="closeBlackboardListDialog" role="presentation">
      <DialogBox role="presentation" onClick={e => e.stopPropagation()}>
        <HeaderBlock>
          <FormattedMessage
            id={`operator.favorites.dialog.title.${
              favorite.id ? 'edit' : 'add'
            }`}
          />
          <CloseButton
            id="closeButton"
            role="presentation"
            className="button"
            onClick={() => close()}
          >
            <CloseButtonImage src={btnClose} alt="close" />
          </CloseButton>
        </HeaderBlock>
        <BodyBlock>
          <ContentWrapper>
            <InputWrapper>
              <InputTitle>
                <FormattedMessage id="operator.favorites.dialog.name" />
              </InputTitle>
              <Input
                id="InputFavorite"
                defaultValue={favorite.name}
                onChange={e =>
                  dispatch({
                    type: Type.INPUT_FAVORITE_NAME,
                    favoriteName: e.target.value,
                  })
                }
              />
            </InputWrapper>
          </ContentWrapper>
          <SubTitle>
            <FormattedMessage id="operator.favorites.dialog.menber" />
          </SubTitle>
          {!noChecked && (
            <RemoteActionWrapper>
              <RemoteMembersWrapper>
                <Fragment key="RemoteMembersWrapper">
                  {oppositeFavoriteOperatorIds.map(operatorId => {
                    const member =
                      oppositeOperators.find(
                        operator => operator.operatorId === operatorId,
                      ) || {};
                    if (!member.name) {
                      return null;
                    }
                    return (
                      <RemoteMember key={`remote-member-${operatorId}`}>
                        <MemberName>{member.name || ''}</MemberName>
                        <CancelButton
                          id={`DeleteRemoteMember-${operatorId}`}
                          role="presentation"
                          className="button"
                          onClick={() => toggleCheckbox(operatorId)}
                        >
                          <CancelButtonImage src={btnClose} alt="close" />
                        </CancelButton>
                      </RemoteMember>
                    );
                  })}
                  <AllClearButton className="button" onClick={resetCheckbox}>
                    <FormattedMessage id="operator.dashboard.remote.clear" />
                  </AllClearButton>
                </Fragment>
              </RemoteMembersWrapper>
            </RemoteActionWrapper>
          )}
          <SearchBox onChange={e => setNamePartial(e.target.value)} />
          <Table>
            <Thead>
              <TheadTr>
                <ThCheckbox>
                  {showAllCheckbox && (
                    <Checkbox
                      checkboxKey="favorite-operators-all"
                      checked={filterOperators.length === checkedTargetCount}
                      onCheck={checkAll}
                    />
                  )}
                </ThCheckbox>
                <ThOperatorName>
                  <SortWrapper
                    className="clickableItem"
                    id="operatorOperatorNameSortMarkClick"
                    role="presentation"
                    onClick={clickSort}
                  >
                    <FormattedMessage id="operator.dashboard.operators.title" />
                    <SortMark sort={sortOn} order={(sortDesc && 'D') || 'A'} />
                  </SortWrapper>
                </ThOperatorName>
              </TheadTr>
            </Thead>
          </Table>
          <ScrolledBody>
            <Table>
              <Tbody>
                {filterOperators &&
                  filterOperators.map((list, idx) => {
                    const onClickOperator = `onClickOperator${idx}`;
                    const checked = oppositeFavoriteOperatorIds.some(
                      operatorId => operatorId === list.operatorId,
                    );
                    return (
                      <TbodyTr
                        id={onClickOperator}
                        key={onClickOperator}
                        checked={checked}
                      >
                        <TdCheckbox>
                          <Checkbox
                            disabled={!checked && !enabledCheck}
                            checkboxKey={`favorite-operators-${idx}`}
                            checked={checked}
                            onCheck={() => toggleCheckbox(list.operatorId)}
                          />
                        </TdCheckbox>
                        <TdOperatorName>
                          <OperatorNameWrapper>
                            <UserIcon url={list.iconUrl} />
                            <OperatorName>{list.name || ''}</OperatorName>
                          </OperatorNameWrapper>
                        </TdOperatorName>
                      </TbodyTr>
                    );
                  })}
              </Tbody>
            </Table>
          </ScrolledBody>
          <ButtonWrapper>
            <AppButton
              large
              bgColor="white"
              color="black"
              borderColor={ColorSF2.mediumGray}
              id="closeButton"
              role="presentation"
              className="button"
              fontSize="16px"
              onClick={() => close()}
            >
              <FormattedMessage id="common.button.cancel" />
            </AppButton>
            {favorite.id && (
              <AppButton
                large
                bgColor={ColorSF2.alertRed}
                id="deleteButton"
                role="presentation"
                className="button"
                fontSize="16px"
                onClick={() => onDelete(favorite.id)}
              >
                <FormattedMessage id="common.button.delete" />
              </AppButton>
            )}
            {favorite.id && (
              <AppButton
                large
                id="updateButton"
                role="presentation"
                className={!disabled && 'button'}
                disabled={disabled}
                fontSize="16px"
                bgColor={ColorSF2.navyBlue}
                onClick={
                  !disabled
                    ? () => {
                        const operatorIds = oppositeFavoriteOperatorIds.concat([
                          userInfo.operatorId,
                        ]);
                        onUpdate(favorite.id, {
                          name: favorite.name,
                          operatorIds,
                        });
                      }
                    : undefined
                }
              >
                <FormattedMessage id="common.button.update" />
              </AppButton>
            )}
            {!favorite.id && (
              <AppButton
                id="createButton"
                role="presentation"
                large
                className={!disabled && 'button'}
                disabled={disabled}
                onClick={
                  !disabled
                    ? () => {
                        const operatorIds = oppositeFavoriteOperatorIds.concat([
                          userInfo.operatorId,
                        ]);
                        onCreate({ name: favorite.name, operatorIds, groupId });
                      }
                    : undefined
                }
              >
                <FormattedMessage id="common.button.create" />
              </AppButton>
            )}
          </ButtonWrapper>
        </BodyBlock>
      </DialogBox>
    </MainBlock>
  );
};

FavoriteDialog.propTypes = {
  apiToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  oppositeOperators: PropTypes.array.isRequired,
  favorite: PropTypes.object.isRequired,
  groupId: PropTypes.string.isRequired,
  userInfo: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  favorite: state.favorite.favorite,
  oppositeOperators: state.favorite.oppositeOperators,
  groupId: state.main.targetGroupId,
});

export default connect(mapStateToProps)(FavoriteDialog);
